import { DialogActions, DialogTitle } from "@mui/material"

import { ProgressBar, SpecialZoomLevel, Viewer, Worker } from "@react-pdf-viewer/core"
import ButtonDialog from "./ButtonsDialog"
import { BootstrapDialog, CustomDialogContent } from "./Dialog"
import { useMemo } from "react"

export function DialogViewPDF({
	title,
	fileName,
	urlFile,
	open,
	setOpen,
	loading = false,
}) {
	const download = useMemo(() => {
		if (fileName) return () => downloadAndRenameFile(urlFile, fileName)

		return () => handleDownload(urlFile)
	}, [fileName, urlFile])

	if (loading) {
		return (
			<BootstrapDialog
				open={open}
				onClose={() => {
					setOpen(false)
				}}
				fullWidth={true}
				maxWidth={"xl"}
			>
				<DialogTitle id="Dialog-Form">{title}</DialogTitle>
				<CustomDialogContent dividers>Cargando...</CustomDialogContent>
			</BootstrapDialog>
		)
	}

	return (
		<BootstrapDialog
			open={open}
			onClose={() => {
				setOpen(false)
			}}
			fullWidth={true}
			maxWidth={"xl"}
		>
			<DialogTitle id="Dialog-Form">{title}</DialogTitle>
			<CustomDialogContent dividers>
				<div>
					<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
						<Viewer
							defaultScale={SpecialZoomLevel.PageWidth}
							fileUrl={urlFile}
							renderLoader={(percentages) => (
								<div style={{ width: "80vh" }}>
									<ProgressBar progress={Math.round(percentages)} />
								</div>
							)}
						/>
					</Worker>
				</div>
			</CustomDialogContent>
			<DialogActions sx={{ alignContent: "center", justifyContent: "center" }}>
				<ButtonDialog label="Cerrar" onClick={() => setOpen(false)} />
				<ButtonDialog label="Descargar" onClick={download} />
			</DialogActions>
		</BootstrapDialog>
	)
}

const handleDownload = (urlFile) => {
	// window.open(response.data, "_blank")
	const link = document.createElement("a")
	link.href = urlFile // La URL del archivo
	// link.download = "nombre_del_archivo.ext" // Nombre del archivo
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
}

const downloadAndRenameFile = async (url, name = null) => {
	const response = await fetch(url)
	const blob = await response.blob()

	const blobUrl = window.URL.createObjectURL(blob)
	const a = document.createElement("a")
	a.href = blobUrl
	a.download = name
	document.body.appendChild(a)
	a.click()
	document.body.removeChild(a)
	window.URL.revokeObjectURL(blobUrl)
}
//https://lbt-rh.s3.amazonaws.com/talent_cloud/TRAC/cursos/2025/00667/1752873646643_Gesti%C3%B3n_integral_de_residuos.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAQ755HY3P3SX5TFGO%2F20250718%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20250718T212837Z&X-Amz-Expires=60&X-Amz-SignedHeaders=host&X-Amz-Signature=7e11c91c6bf88e6964a57b0f9e2e8d3d4275e711e97666d64573bf53c18a44fc"
